import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import { PlayIcon, ClockIcon, BookOpenIcon, MoreVerticalIcon, LockIcon, StarIcon } from 'lucide-react';
// Corsi attivi
const activeCourses = [{
  id: 1,
  title: 'Climate Change 101: cosa dice la scienza',
  description: 'Basi scientifiche essenziali per capire cause, impatti e scenari del cambiamento climatico, senza tecnicismi inutili.',
  image: 'https://www.innovationnewsnetwork.com/wp-content/uploads/2020/03/image-1.jpg',
  progress: 65,
  modulesCompleted: 2,
  totalModules: 3,
  lastActive: true,
  timeLeft: '1h 30m',
  isActive: true
}, {
  id: 2,
  title: 'Casa efficiente: energia, bollette e comfort',
  description: "Piccoli interventi e abitudini per ridurre consumi e costi, migliorando comfort e qualità dell'aria.",
  image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&q=80',
  progress: 33,
  modulesCompleted: 1,
  totalModules: 3,
  lastActive: false,
  timeLeft: '2h 15m',
  isActive: true
}, {
  id: 3,
  title: 'Mobilità sostenibile: muoversi meglio, spendere meno',
  description: "Strategie realistiche per ridurre l'impatto degli spostamenti, senza perdere tempo.",
  image: 'https://images.unsplash.com/photo-1571068316344-75bc76f77890?w=800&q=80',
  progress: 0,
  modulesCompleted: 0,
  totalModules: 3,
  lastActive: false,
  timeLeft: '2h 00m',
  isActive: true
}];
// Corsi acquistabili con Star credits
const starCourses = [{
  id: 4,
  title: 'Cibo e clima: scelte semplici ad alto impatto',
  description: 'Come alimentazione e spreco incidono su emissioni, biodiversità e risorse, con azioni pratiche.',
  image: 'https://images.unsplash.com/photo-1490818387583-1baba5e638af?w=800&q=80',
  totalModules: 3,
  starCost: 50,
  isLocked: true
}, {
  id: 5,
  title: 'Rifiuti e plastiche: ridurre, riusare, riciclare',
  description: 'Passare dalla teoria alla pratica: meno rifiuti, meno plastica, più riuso.',
  image: 'https://images.unsplash.com/photo-1532996122724-e3c354a0b15b?w=800&q=80',
  totalModules: 3,
  starCost: 50,
  isLocked: true
}, {
  id: 6,
  title: 'Green claims: come riconoscere il greenwashing',
  description: 'Strumenti pratici per valutare dichiarazioni ambientali, etichette e promesse "green".',
  image: 'https://images.unsplash.com/photo-1532629345422-7515f3d16bb6?w=800&q=80',
  totalModules: 3,
  starCost: 50,
  isLocked: true
}, {
  id: 7,
  title: 'Biodiversità: perché conta (e cosa puoi fare)',
  description: 'Biodiversità e servizi ecosistemici spiegati in modo concreto, con azioni locali.',
  image: 'https://images.unsplash.com/photo-1535083783855-76ae62b2914e?w=800&q=80',
  totalModules: 3,
  starCost: 50,
  isLocked: true
}, {
  id: 8,
  title: 'Azioni certificate: prove, trasparenza e fiducia',
  description: 'Come funzionano le azioni certificate in Greenback, quando servono prove, cosa viene approvato e perché.',
  image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&q=80',
  totalModules: 3,
  starCost: 50,
  isLocked: true
}];
const CoursesPage = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  return <div className="flex h-screen bg-gray-50" data-id="element-2370">
      {/* Mobile sidebar */}
      <div className={`fixed inset-0 z-40 md:hidden ${sidebarOpen ? 'block' : 'hidden'}`} data-id="element-2371">
        <div className="fixed inset-0 bg-gray-600 bg-opacity-75" onClick={() => setSidebarOpen(false)} data-id="element-2372"></div>
        <div className="relative flex-1 flex flex-col w-2/3 h-full bg-black" data-id="element-2373">
          <div className="flex-1 h-full overflow-y-auto" data-id="element-2374">
            <Sidebar activePage="formazione" data-id="element-2375" />
          </div>
        </div>
      </div>

      {/* Static sidebar for desktop */}
      <div className="hidden md:flex md:flex-shrink-0" data-id="element-2376">
        <Sidebar activePage="formazione" data-id="element-2377" />
      </div>

      <div className="flex flex-col flex-1 overflow-hidden" data-id="element-2378">
        <Topbar onMenuClick={() => setSidebarOpen(true)} data-id="element-2379" />

        <main className="flex-1 overflow-y-auto p-4 md:p-8 bg-gray-50" data-id="element-2380">
          <div className="max-w-7xl mx-auto" data-id="element-2381">
            <div className="flex justify-between items-center mb-8" data-id="element-2382">
              <div data-id="element-2383">
                <h1 className="text-2xl font-normal text-gray-900" data-id="element-2384">
                  I Miei Corsi
                </h1>
                <p className="text-sm text-gray-600 font-normal mt-1" data-id="element-2385">
                  Gestisci e prosegui il tuo percorso formativo
                </p>
              </div>
            </div>

            {/* Corsi Attivi */}
            <div className="mb-12" data-id="element-2386">
              <h2 className="text-lg font-normal text-gray-900 mb-4" data-id="element-2387">
                Corsi Attivi
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-2388">
                {activeCourses.map(course => <CourseCard key={course.id} course={course} data-id="element-2389" />)}
              </div>
            </div>

            {/* Corsi Acquistabili */}
            <div data-id="element-2390">
              <div className="flex items-center gap-3 mb-4" data-id="element-2391">
                <h2 className="text-lg font-normal text-gray-900" data-id="element-2392">
                  Acquista con Star Credits
                </h2>
                <div className="flex items-center gap-1 px-2 py-1 bg-yellow-50 border border-yellow-200 rounded-full" data-id="element-2393">
                  <StarIcon size={14} className="text-yellow-500 fill-yellow-500" strokeWidth={1.5} data-id="element-2394" />
                  <span className="text-xs font-normal text-yellow-700" data-id="element-2395">
                    50 per corso
                  </span>
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-2396">
                {starCourses.map(course => <LockedCourseCard key={course.id} course={course} data-id="element-2397" />)}
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>;
};
interface CourseCardProps {
  course: {
    id: number;
    title: string;
    description: string;
    image: string;
    progress: number;
    modulesCompleted: number;
    totalModules: number;
    lastActive: boolean;
    timeLeft: string;
  };
}
const CourseCard: React.FC<CourseCardProps> = ({
  course
}) => {
  return <div className="bg-white rounded-xl border border-gray-100 overflow-hidden hover:border-green-600 transition-all flex flex-col h-full" data-id="element-2398">
      <div className="relative h-48 overflow-hidden" data-id="element-2399">
        <img src={course.image} alt={course.title} className="w-full h-full object-cover" data-id="element-2400" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" data-id="element-2401"></div>
        {course.lastActive && <div className="absolute top-3 right-3 bg-green-600 text-white text-xs font-normal px-2 py-1 rounded-full shadow-sm" data-id="element-2402">
            ULTIMO ATTIVO
          </div>}
      </div>

      <div className="p-5 flex-1 flex flex-col" data-id="element-2403">
        <div className="flex justify-between items-start mb-2" data-id="element-2404">
          <h3 className="text-lg font-normal text-gray-900 line-clamp-2 mb-1" data-id="element-2405">
            {course.title}
          </h3>
          <button className="text-gray-400 hover:text-gray-600 transition-colors" data-id="element-2406">
            <MoreVerticalIcon size={20} strokeWidth={1.5} data-id="element-2407" />
          </button>
        </div>

        <p className="text-sm text-gray-600 font-normal mb-4 line-clamp-2 leading-relaxed" data-id="element-2408">
          {course.description}
        </p>

        <div className="mt-auto" data-id="element-2409">
          <div className="flex justify-between text-xs text-gray-500 font-normal mb-1" data-id="element-2410">
            <span data-id="element-2411">Progresso</span>
            <span className="font-normal text-gray-900" data-id="element-2412">
              {course.progress}%
            </span>
          </div>
          <div className="w-full bg-gray-100 rounded-full h-1.5 mb-4" data-id="element-2413">
            <div className="bg-green-600 h-full rounded-full transition-all duration-500" style={{
            width: `${course.progress}%`
          }} data-id="element-2414"></div>
          </div>

          <div className="flex items-center justify-between text-xs text-gray-500 font-normal mb-4" data-id="element-2415">
            <div className="flex items-center" data-id="element-2416">
              <BookOpenIcon size={14} className="mr-1" strokeWidth={1.5} data-id="element-2417" />
              <span data-id="element-2418">
                {course.modulesCompleted}/{course.totalModules} Moduli
              </span>
            </div>
            <div className="flex items-center" data-id="element-2419">
              <ClockIcon size={14} className="mr-1" strokeWidth={1.5} data-id="element-2420" />
              <span data-id="element-2421">{course.timeLeft}</span>
            </div>
          </div>

          <Link to={`/corso/${course.id}`} className={`w-full flex items-center justify-center py-2.5 rounded-full text-sm font-normal transition-colors ${course.progress > 0 ? 'bg-green-600 text-white hover:bg-green-700' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-2422">
            {course.progress > 0 ? <>
                <PlayIcon size={16} className="mr-2" strokeWidth={1.5} data-id="element-2423" />
                Continua
              </> : <>
                <PlayIcon size={16} className="mr-2" strokeWidth={1.5} data-id="element-2424" />
                Inizia Corso
              </>}
          </Link>
        </div>
      </div>
    </div>;
};
interface LockedCourseCardProps {
  course: {
    id: number;
    title: string;
    description: string;
    image: string;
    totalModules: number;
    starCost: number;
  };
}
const LockedCourseCard: React.FC<LockedCourseCardProps> = ({
  course
}) => {
  return <div className="bg-white rounded-xl border border-gray-100 overflow-hidden hover:border-green-600 transition-all flex flex-col h-full opacity-90" data-id="element-2425">
      <div className="relative h-48 overflow-hidden" data-id="element-2426">
        <img src={course.image} alt={course.title} className="w-full h-full object-cover" data-id="element-2427" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" data-id="element-2428"></div>
        <div className="absolute inset-0 flex items-center justify-center" data-id="element-2429">
          <div className="bg-white/90 backdrop-blur-sm rounded-full p-3 shadow-lg" data-id="element-2430">
            <LockIcon size={24} className="text-gray-700" strokeWidth={1.5} data-id="element-2431" />
          </div>
        </div>
      </div>

      <div className="p-5 flex-1 flex flex-col" data-id="element-2432">
        <div className="flex justify-between items-start mb-2" data-id="element-2433">
          <h3 className="text-lg font-normal text-gray-900 line-clamp-2 mb-1" data-id="element-2434">
            {course.title}
          </h3>
        </div>

        <p className="text-sm text-gray-600 font-normal mb-4 line-clamp-2 leading-relaxed" data-id="element-2435">
          {course.description}
        </p>

        <div className="mt-auto" data-id="element-2436">
          <div className="flex items-center justify-between text-xs text-gray-500 font-normal mb-4" data-id="element-2437">
            <div className="flex items-center" data-id="element-2438">
              <BookOpenIcon size={14} className="mr-1" strokeWidth={1.5} data-id="element-2439" />
              <span data-id="element-2440">{course.totalModules} Moduli</span>
            </div>
          </div>

          <button className="w-full flex items-center justify-center py-2.5 rounded-full text-sm font-normal transition-colors bg-gradient-to-br from-yellow-400 to-yellow-500 text-white hover:from-yellow-500 hover:to-yellow-600 shadow-sm" data-id="element-2441">
            <StarIcon size={16} className="mr-2 fill-white" strokeWidth={1.5} data-id="element-2442" />
            Acquista con {course.starCost} Star
          </button>
        </div>
      </div>
    </div>;
};
export default CoursesPage;